import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  ADD_USER,
  GET_USERS,
  GET_USER_BY_ID,
  MODIFY_USER,
  SET_EDITING_USER,
  TOGGLE_USER,
  UPDATE_USER,
  SET_USERS_FILTERS,
  SET_USERS_PAGINATION,
} from 'users/constants';

import { normalize, schema } from 'normalizr';
import { ALL, selectionFromList } from 'lib/subcompanyAccess';

const user = new schema.Entity('users');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['name', 'lastname', 'email'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  result: {},
  entities: {},
  editing: {
    email: '',
    roleId: '',
    // feature/acceso-subcompanias: "Todas" by default (lib/subcompanyAccess)
    subcompaniesSelection: ALL,
    isSaving: false,
    isLoading: false,
  },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getRejected = (state) => ({ ...state, isLoading: false });

export const getFulfilled = (
  state,
  { payload: { page, limit, totalPages, records, totalDocs } }
) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    page,
    limit,
    totalPages,
    totalDocs,
  },
  ...normalize({ users: records }, { users: [user] }),
});

export const modifyUser = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, ...payload },
});

export const setEditingUser = (state) => ({
  ...state,
  editing: initialState.editing,
});

export const addPending = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: true },
});
export const addRejected = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});
export const addFulfilled = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});

export const updatePending = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: true },
});
export const updateRejected = (state) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});
export const updateFulfilled = (state, { payload }) => ({
  ...state,
  editing: { ...state.editing, isSaving: false },
});

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    users: {
      ...state.entities.users,
      [meta.id]: { ...state.entities.users[meta.id], isSaving: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    users: {
      ...state.entities.users,
      [meta.id]: { ...state.entities.users[meta.id], isSaving: false },
    },
  },
});
export const toggleFulfilled = (state, { meta, payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    users: {
      ...state.entities.users,
      [meta.id]: { ...payload.user, isSaving: false },
    },
  },
});

export const getByIdPending = (state) => ({
  ...state,
  editing: { ...state.editing, isLoading: true },
});

export const getByIdRejected = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    isLoading: false,
  },
});

export const getByIdFulfilled = (state, { payload: { user } }) => {
  const {
    company: {
      role: { id },
      subcompanies,
    },
  } = user;
  delete user.company;
  return {
    ...state,
    editing: {
      ...user,
      roleId: id,
      subcompaniesSelection: selectionFromList(subcompanies),
      isLoading: false,
    },
  };
};

export const setFilters = (state, { payload }) => ({
  ...state,
  filters: { ...state.filters, ...payload },
  needFetch: true,
});

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: {
    ...state.pagination,
    ...payload,
  },
});

const userReducers = {
  [GET_USERS]: {
    [PENDING]: getPending,
    [REJECTED]: getRejected,
    [FULFILLED]: getFulfilled,
  },
  [GET_USER_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [ADD_USER]: {
    [PENDING]: addPending,
    [REJECTED]: addRejected,
    [FULFILLED]: addFulfilled,
  },
  [UPDATE_USER]: {
    [PENDING]: updatePending,
    [REJECTED]: updateRejected,
    [FULFILLED]: updateFulfilled,
  },
  [TOGGLE_USER]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
  [SET_EDITING_USER]: setEditingUser,
  [MODIFY_USER]: modifyUser,
  [SET_USERS_FILTERS]: setFilters,
  [SET_USERS_PAGINATION]: setPagination,
};

export default TypeToReducer(userReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/users/reducers/users_reducers.js